export default "MaPrimeRénov’ Copropriété finance jusqu'à 45% des travaux collectifs de rénovation énergétique. Conditions d'éligibilité, montants, démarche syndicale et accompagnement.";
